export default __webpack_public_path__ + "static/media/delete_outline_black_24dp.31315aa9.svg";